import { ImageFile } from '../entities/ImageFile';

export function isBlob(file: ImageFile | string): file is ImageFile {
    return !!(file && (file as ImageFile).preview);
}
